const Categories = require('../model/Categories');
const ChannelDefinition = require('../model/ChannelDefinition');

class SearchWidgetChannel extends ChannelDefinition {
	id = 'search-widget';
	title = 'Search Widget';
	description = 'Add a searchable product widget to your own website powered by your Local Storefront inventory.';
	category = Categories.OMNICHANNEL_EXPERIENCE;

	iconUrl = 'https://images.near.st/channels/nearst.png';
	coverImageUrl = 'https://images.near.st/channels/headers/search-widget.png';

	longDescription = `
## Overview
The Search Widget is a lightweight embed for your own website. Customers can search your live in-store inventory by keyword or barcode and click through to your Local Storefront product page.

## How it works
Copy a short snippet from your Unify dashboard and paste it into your website. The widget renders a search box; as customers type, matching products drop down beneath it. A click opens the product on your Local Storefront so the shopper sees stock availability, opening hours and directions.

## Requirements
- A website you can add a small HTML snippet to
- Your Local Storefront enabled (on by default for all Unify stores)

## Customisation
The snippet accepts a handful of \`data-*\` attributes so the widget can be tuned to your site's brand — primary colour, corner radius, font family and placeholder text. Copy defaults from the manage page and edit inline.
	`;

	manageUrl = '/channels/{shopId}/settings/search-widget';
	productSpecificVisibility = true;

	worksWith = ['storefront'];

	helpArticleUrls = [
		{
			title: 'Install guide',
			url: 'https://support.unify.near.st/search-widget'
		}
	];
}

module.exports = SearchWidgetChannel;
